import styled from 'styled-components';
import { AlliePopover } from '../../../components/Popover';

interface StyledLinkProps {
  ellipsis?: boolean;
  width?: number;
}

export const StyledLinkText = styled.span<StyledLinkProps>`
  ${(props: StyledLinkProps) => props.ellipsis ? 'display: block !important' : ''};
  ${(props: StyledLinkProps) => props.ellipsis ? `max-width: ${props.width}px` : ''};
  ${(props: StyledLinkProps) => props.ellipsis ? 'text-overflow: ellipsis' : ''};
  ${(props: StyledLinkProps) => props.ellipsis ? 'overflow: hidden' : ''};
  };
`;

export const StyledAlliePopover = styled(AlliePopover)`
  &&{--width: fit-content}
  &&{--offset-x: 5px}
  &&{--offset-y: 40px}
`;
